import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { IoMdPerson } from "react-icons/io";
import { IoIosMenu } from "react-icons/io";
import { MdFavorite } from "react-icons/md";
import { TiPointOfInterest } from "react-icons/ti";
import { TfiReceipt } from "react-icons/tfi";
import { MdLogout } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ClickAwayListener from "react-click-away-listener";
import { logout } from "../Redux/Action/LoginAction/loginAction";
import "./Header.css";
import swal from "sweetalert";
import {
  shouldLogoutDueToMissingToken,
  isTokenValid,
} from "../Utils/authUtils";

import { getStateList, setLocation } from "../Redux/Action/LocationAction";
import StateDropdown from "./StateDropdown";
import {
  getLocalHightlight,
  setLocalHighlightPageCount,
} from "../Redux/Action/BusinessAction/businesAction";
import {
  BRIGIZ_APP_E_COM_ADDRESS,
  BRIGIZ_APP_E_COM_HOME,
  BRIGIZ_APP_E_COM_ORDER,
  BRIGIZ_APP_E_COM_WISHLIST,
  BRIGIZ_APP_E_COM_TRACK_ORDER,
  LATITUDE,
  LONGITUDE,
} from "../Utils/constants";
import {
  AD_PURCHASE,
  CONTACT,
  EVENTS,
  EXPLORE_APP,
  HOME,
  LOGIN,
  MY_OFFER_PAGE,
  SIGNIN,
  WHY_BRIGIZ,
} from "../Routes/RoutesConstant";
import {
  searchBusiness,
  getBusinessTypeList,
} from "../Redux/Action/BusinessAction/businesAction";
import SelectBox from "./select-box";
import { isEmpty } from "lodash";
import { skeletonAction } from "../Redux/Action/loadingAction";
import { BUSINESS_SEARCH } from "../Utils/constants";
import { BiMessageDetail } from "react-icons/bi";
import { FaShoppingCart } from "react-icons/fa";
import { TbAddressBook } from "react-icons/tb";
import TopBar from "./TopBar";
import TrackOrder from "../assets/images/TrackOrder";

const icon_trasaction = require("../assets/images/icon-transaction.svg");

const Header = (props) => {
  const showState = props?.showState;
  const loginShow = props.loginShow;
  // const [loginShow, setLoginShow] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = useLocation();
  const { type } = useParams();
  const [toggle, setToggle] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const totalUnreadCount = localStorage.getItem("totalUnreadCount");

  // Token validation function
  const validateToken = useCallback(() => {
    if (shouldLogoutDueToMissingToken()) {
      console.log("Token validation failed in Header, logging out user");
      dispatch(logout());
      // navigate("/login", { replace: true });
      return false;
    }

    return isTokenValid();
  }, [dispatch, navigate]);

  // Check token on component mount and when dropdown opens
  useEffect(() => {
    validateToken();
  }, [validateToken]);

  useEffect(() => {
    if (isDropdownOpen) {
      // Validate token when user opens profile dropdown
      if (!validateToken()) {
        setIsDropdownOpen(false);
        return;
      }
    }
  }, [isDropdownOpen, validateToken]);

  useEffect(() => {
    if (toggle) {
      // Save current scroll position
      const scrollY = window.scrollY;

      // Add styles to body
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      // Get scroll position
      const scrollY = document.body.style.top;

      // Remove styles from body
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";

      // Restore scroll position
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }

    // Cleanup function
    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    };
  }, [toggle]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    setIsDropdownOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // const accessToken = localStorage.getItem("accessToken");

  const [searchInput, setSearchInput] = useState("");
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [typeSelect, setTypeSelect] = useState("0");
  const [typeName, setTypeName] = useState("");
  const [isLocationEnabled, setIsLocationEnabled] = useState(false);
  const { stateList, selectedState } = useSelector(
    (state) => state.locationReducer
  );
  const accessToken = useSelector(
    (state) => state?.LoginData?.loginDataSuccess?.access_token
  );

  const { businessSearchSuccess, localHighlightPageNo, businessTypeList } =
    useSelector((state) => state.businessData);

  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsActive, setSuggestionsActive] = useState(false);
  const [reset, setReset] = useState(false);
  var path = window.location.pathname;
  var page = path.split("/").pop();
  const user_uuid = localStorage.getItem("user_uuid");

  useEffect(() => {
    if (
      !isEmpty(businessSearchSuccess?.data) &&
      page === "BusinessSearchResult"
    ) {
      setTypeSelect(
        businessSearchSuccess?.data?.business_type.length > 0
          ? businessSearchSuccess?.data?.business_type[0]
          : "0"
      );
      setTypeName(businessSearchSuccess?.data?.business_type_name);
      setSearchInput(businessSearchSuccess?.data?.text);
      setSuggestionsActive(false);
    }
  }, [page]);

  // useEffect(() => {
  //   const lat = localStorage.getItem("latitude");
  //   const lng = localStorage.getItem("longitude");

  //   const isEnabled = lat && lng && !(lat == LATITUDE && lng == LONGITUDE);
  //   setIsLocationEnabled(isEnabled);
  // }, [accessToken]);

  const {
    latLng: { lat, lng },
  } = useSelector((state) => state.locationReducer);

  const currentState = stateList.find((s) => s.state_code === selectedState);
  // const accessToken = data.LoginData?.accessToken;
  useEffect(() => {
    dispatch(getStateList());
  }, []);

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 100);
    };
  };

  // useEffect(() => {
  //   searchInput.length > 0 && debouncVersion(searchInput);
  // }, [searchInput]);
  // // console.log(typeof(typeSelect), 'typeSelect')

  const getSuggestion = async (value) => {
    // setSearchInput(e.target.value);
    const query = value;
    // setValue(e.target.value.toLowerCase());
    if (query.length > 1) {
      let body = {
        user_uuid: user_uuid,
        lat: localStorage.getItem("latitude") || 21.150058,
        lng: localStorage.getItem("longitude") || 72.8548533,
        range: 50000,
        text: query,
        page: 1,
        limit: 20,
        business_type: typeSelect === "0" ? [] : [typeSelect],
        business_type_name: typeName,
      };

      let result = await dispatch(searchBusiness(body));

      if (result?.payload?.businessList.length > 0) {
        setSuggestions(result?.payload?.businessList);
        setSuggestionsActive(true);
      }
      // const filterSuggestions = data.filter(
      //   (suggestion) =>
      //     suggestion.toLowerCase().indexOf(query) > -1
      // );
      // setSuggestions(filterSuggestions);
      // setSuggestionsActive(true);
    } else {
      setSuggestionsActive(false);
    }
  };

  const debouncVersion = useCallback(debounce(getSuggestion), [typeSelect]);

  useEffect(() => {
    if (isEmpty(businessTypeList)) {
      dispatch(getBusinessTypeList());
    }
  }, []); // Only run on mount

  useEffect(() => {
    setToggle(false);
  }, [location]);

  const body = {
    page: localHighlightPageNo,
    text: "",
    fetchtype: "seeall",
    user_uuid: user_uuid,
    limit: 12,
    state: currentState?.state || "",
    state_code: currentState?.state_code || "",
    lat,
    lng,
  };

  useEffect(() => {
    if (localHighlightPageNo === 1) {
      if (location.pathname === HOME) dispatch(getLocalHightlight(body));
    } else {
      dispatch(setLocalHighlightPageCount(1));
    }
  }, [currentState, lat, lng, location]);

  useEffect(() => {
    if (location.pathname === HOME) dispatch(getLocalHightlight(body));
  }, [localHighlightPageNo]);

  const logoutbutton = async () => {
    try {
      const response = await dispatch(logout());
      const logoutData = response?.payload;
      if (logoutData) {
        if (logoutData == "LOGOUT") {
          navigate("/");
        } else {
          swal({
            title: "error!",
            text: logoutData?.data?.message,
            buttons: false,
            icon: "error",
            timer: 2000,
          });
        }
      }
    } catch (error) {
      swal({
        title: "Error",
        text: error?.message,
        buttons: false,
        icon: "error",
        timer: 2000,
      });
    }
  };
  const searchHandle = async (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    let body = {
      user_uuid: user_uuid,
      lat: localStorage.getItem("latitude") || 21.150058,
      lng: localStorage.getItem("longitude") || 72.8548533,
      range: 50000,
      text: value,
      page: 1,
      limit: 10,
      business_type: typeSelect === "0" ? [] : [typeSelect],
      business_type_name: typeName === "Select Type" ? "" : typeName,
    };
    dispatch(skeletonAction(true, BUSINESS_SEARCH));

    let result = await dispatch(searchBusiness(body));
    if (result.type === "SEARCH_BUSINESS_SUCCESS") {
      dispatch(skeletonAction(false, BUSINESS_SEARCH));
      setSuggestionsActive(false);
      navigate("/BusinessSearchResult", {
        state: { result: result.payload, body },
      });
    }
  };

  const renderBusinessType = () => {
    return (
      !isEmpty(businessTypeList) &&
      businessTypeList.map((item, index) => {
        return (
          <div className="home_select_option" id={item.id} key={index}>
            {item.business_type}
          </div>
        );
      })
    );
  };
  const handleSelectChange = (e) => {
    var selectedOption = e.target.selectedOptions[0];
    if (e.target.value != "") {
      setTypeSelect(selectedOption.value);
      setTypeName(selectedOption.text);
    }
  };
  const handleInputChange = (e) => {
    setSearchInput(e.target.value);
    setShowSuggestion(true);
  };

  const Suggestions = () => {
    return (
      <ul className="suggestions">
        {suggestions?.map((item, index) => {
          return (
            <li className="" key={index} onClick={handleClick}>
              {item.business_name}
            </li>
          );
        })}
      </ul>
    );
  };
  const handleClick = (e) => {
    setSuggestions([]);
    setSuggestionsActive(false);
    searchHandle(e, e.target.innerText);
  };
  return (
    <section className="br-header">
      {/* <TopBar /> */}
      <nav className="navbar navbar-expand-md navbar-light bg-light px-2">
        <ClickAwayListener onClickAway={() => setToggle(false)}>
          <div className="container">
            <div
              className="navbar-brand"
              style={{ cursor: "pointer" }}
              onClick={() => location.pathname !== HOME && navigate("/")}
            >
              <img src="../images/img-logo.png" />
            </div>

            <a
              href="https://jamaica.brigiz.com/"
              className="nav-link"
              id="jamaica-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Now Available In Jamaica
            </a>

            <button
              className="navbar-toggler"
              type="button"
              aria-label="Toggle navigation"
              onClick={() => setToggle(!toggle)}
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className={`collapse navbar-collapse ${toggle ? "show" : ""}`}
              id="navbarNavAltMarkup"
            >
              <div
                className="navbar-nav"
                style={{
                  justifyContent:
                    showState && currentState ? "flex-end" : "flex-end",
                }}
              >
                {pathname !== "/" && pathname !== "/chat" && (
                  <form
                    className="wow fadeInUp my-1 form-search"
                    onSubmit={(e) => searchHandle(e, searchInput)}
                    style={{
                      alignSelf: "center",
                      width:
                        showState && currentState
                          ? "width-control-30"
                          : "width-control-40",
                    }}
                  >
                    <div
                      className="main-srch homeSearchField "
                      style={{
                        alignItems: "baseline",
                        justifyContent: "center",
                      }}
                    >
                      <select
                        aria-label="Select Type"
                        className="select_box"
                        style={{ height: "36px", border: "none" }}
                        onChange={handleSelectChange}
                        value={typeSelect}
                        defaultChecked={typeSelect}
                      >
                        <option value={"0"} className="selectbox_content">
                          Select Type
                        </option>
                        {!isEmpty(businessTypeList) &&
                          businessTypeList?.map((val, idx) => (
                            <option
                              value={val?.id}
                              name={val?.business_type}
                              className="selectbox_content"
                              key={idx}
                            >
                              {val?.business_type}
                            </option>
                          ))}
                      </select>
                      <ClickAwayListener
                        onClickAway={() => {
                          setSuggestions([]);
                          setSuggestionsActive(false);
                        }}
                      >
                        <div
                          className="searchInput"
                          style={{ position: "relative", width: "100%" }}
                        >
                          <input
                            type="text"
                            name="search"
                            placeholder="Search business"
                            onChange={handleInputChange}
                            value={searchInput}
                            style={{ height: "36px" }}
                          />
                          <button
                            className="br-search-btn"
                            style={{ verticalAlign: "top" }}
                          >
                            <img src="/images/green-srch.svg" />
                          </button>
                          {suggestionsActive && <Suggestions />}
                        </div>
                      </ClickAwayListener>
                    </div>
                  </form>
                )}
                {showState && currentState && (
                  <StateDropdown
                    currentState={currentState}
                    onChange={(e) => dispatch(setLocation(e.target.id))}
                  />
                )}
                {/* <Link
                  className={
                    "nav-link" + (location.pathname === HOME ? " active" : "")
                  }
                  aria-current="page"
                  to={HOME}
                  onClick={() => {
                    setTypeSelect("0");
                    setSearchInput("");
                  }}
                >
                  Home
                </Link> */}
                <Link
                  className={
                    "nav-link" +
                    (location.pathname === AD_PURCHASE ? " active" : "")
                  }
                  to={AD_PURCHASE}
                  onClick={() => {
                    if (location.pathname !== AD_PURCHASE) {
                      setTypeSelect("0");
                      setSearchInput("");
                    }
                  }}
                >
                  Ad Purchase
                </Link>
                <Link
                  className={
                    "nav-link" +
                    (location.pathname === WHY_BRIGIZ ? " active" : "")
                  }
                  to={WHY_BRIGIZ}
                  onClick={() => {
                    if (location.pathname !== WHY_BRIGIZ) {
                      setTypeSelect("0");
                      setSearchInput("");
                    }
                  }}
                >
                  Why Brigiz
                </Link>
                <Link
                  className={
                    "nav-link" +
                    (location.pathname === EXPLORE_APP ? " active" : "")
                  }
                  to={EXPLORE_APP}
                  onClick={() => {
                    if (location.pathname !== EXPLORE_APP) {
                      setTypeSelect("0");
                      setSearchInput("");
                    }
                  }}
                >
                  Explore Brigiz
                </Link>
                {/* <a href={BRIGIZ_APP_E_COM_HOME} className={"nav-link"}>
                  Shop
                </a> */}

                {/* <Link
                  className={
                    "nav-link" +
                    (location.pathname === CONTACT ? " active" : "")
                  }
                  to={CONTACT}
                  onClick={() => {
                    if (location.pathname !== CONTACT) {
                      setTypeSelect("0");
                      setSearchInput("");
                    }
                  }}
                >
                  Contact Us
                </Link> */}

                {(loginShow || accessToken) && (
                  <>
                    {accessToken ? (
                      <>
                        <button
                          className="profile-sidebar-btn btn-sm"
                          id="profile-sidebar-btn"
                          onClick={() => {
                            setIsDropdownOpen(!isDropdownOpen);
                            console.log(
                              loginShow,
                              "Dropdown toggled:",
                              !isDropdownOpen
                            );
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100px",
                              gap: "6px",
                            }}
                          >
                            <IoIosMenu
                              style={{ width: "18px", height: "18px" }}
                            />
                            <IoMdPerson
                              style={{ width: "18px", height: "18px" }}
                            />
                          </div>
                        </button>
                        <div
                          className="header-barber-accordion"
                          style={{ width: "220px" }}
                        >
                          <div className="accordion" id="accordionExample">
                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingOne">
                                <button
                                  className="accordion-button header-accordion-btn collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#my-profile"
                                  aria-expanded="true"
                                  aria-controls="my-profile"
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "400",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <IoMdPerson
                                    style={{ width: "14px", height: "14px" }}
                                  />
                                  My Profile
                                </button>
                              </h2>

                              <div
                                id="my-profile"
                                className="accordion-collapse collapse "
                                aria-labelledby="headingOpenHours"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  {" "}
                                  <nav>
                                    <Link
                                      to="/edit-profile"
                                      onClick={() => setIsDropdownOpen(false)}
                                    >
                                      Edit Profile
                                    </Link>
                                    {/* <a
                                      href={BRIGIZ_APP_E_COM_TRACK_ORDER}
                                      onClick={() => setIsDropdownOpen(false)}
                                      style={{color:'#ded8d8', textDecoration: 'none', padding: '15px 20px', fontSize: '12px'}}
                                    >
                                      Track Your Order
                                    </a> */}
                                    <Link
                                      to="/favorite"
                                      onClick={() => setIsDropdownOpen(false)}
                                    >
                                      Favorites
                                    </Link>

                                    <Link
                                      to="/my-interest"
                                      onClick={() => setIsDropdownOpen(false)}
                                    >
                                      My Interest
                                    </Link>
                                    <Link
                                      to={MY_OFFER_PAGE}
                                      onClick={() => setIsDropdownOpen(false)}
                                    >
                                      My Offers
                                    </Link>
                                    <Link
                                      to="/transaction-history"
                                      onClick={() => setIsDropdownOpen(false)}
                                    >
                                      Transaction History
                                    </Link>
                                    <Link
                                      to="/logout"
                                      onClick={() => {
                                        setIsDropdownOpen(false);
                                        logoutbutton();
                                      }}
                                    >
                                      <MdLogout
                                        style={{
                                          width: "18px",
                                          height: "18px",
                                          marginRight: "8px",
                                        }}
                                      />
                                      Log Out
                                    </Link>
                                  </nav>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <Link className="nav-link" id="login-btn" to={SIGNIN}>
                        Login
                      </Link>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </ClickAwayListener>
      </nav>

      {isDropdownOpen && (
        <div className="dropdown-menu" ref={dropdownRef}>
          <nav>
            <Link to="/edit-profile" onClick={() => setIsDropdownOpen(false)}>
              <IoMdPerson
                style={{ width: "18px", height: "18px", marginRight: "8px" }}
              />
              Edit Profile
            </Link>
            {/* <div className="dropdown-divider"></div>
            <a
              href={BRIGIZ_APP_E_COM_TRACK_ORDER}
              onClick={() => setIsDropdownOpen(false)}
              style={{color:'#ded8d8'}}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between",gap:"0.35rem"}}>
                <TrackOrder style={{ width: "18px", height: "18px", marginRight: "0.35rem" }} />
                Track Your Order
              </div>
            </a> */}
            <div className="dropdown-divider"></div>
            <Link to="/favorite" onClick={() => setIsDropdownOpen(false)}>
              <MdFavorite
                style={{ width: "18px", height: "18px", marginRight: "8px" }}
              />
              Favorites
            </Link>

            <div className="dropdown-divider"></div>
            <Link to="/my-interest" onClick={() => setIsDropdownOpen(false)}>
              <TiPointOfInterest
                style={{ width: "18px", height: "18px", marginRight: "8px" }}
              />
              My Interest
            </Link>
            <div className="dropdown-divider"></div>
            <Link to={MY_OFFER_PAGE} onClick={() => setIsDropdownOpen(false)}>
              <TiPointOfInterest
                style={{ width: "18px", height: "18px", marginRight: "8px" }}
              />
              My Offers
            </Link>
            <div className="dropdown-divider"></div>
            <Link
              to="/transaction-history"
              onClick={() => setIsDropdownOpen(false)}
            >
              <TfiReceipt
                style={{ width: "17px", height: "17px", marginRight: "8px" }}
              />
              Transaction History
            </Link>
            {/* <div className="dropdown-divider"></div> */}
            {/* <Link
              to="/chat"
              onClick={() => setIsDropdownOpen(false)}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <BiMessageDetail
                  style={{ width: "17px", height: "17px", marginRight: "8px" }}
                />
                Messages
                {totalUnreadCount > 0 && (
                  <div className="unread-count" style={{ marginLeft: "5px" }}>
                    {totalUnreadCount}
                  </div>)}
              </div>
            </Link> */}
            {/* <div className="dropdown-divider"></div>
            <a
              href={BRIGIZ_APP_E_COM_ORDER}
              onClick={() => setIsDropdownOpen(false)}
              style={{color:'#ded8d8'}}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <FaShoppingCart
                  style={{ width: "17px", height: "17px", marginRight: "8px" }}
                />
                Order
              </div>
            </a>
            <div className="dropdown-divider"></div>
            <a
              href={BRIGIZ_APP_E_COM_WISHLIST}
              onClick={() => setIsDropdownOpen(false)}
              style={{color:'#ded8d8'}}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <MdFavorite
                style={{ width: "18px", height: "18px", marginRight: "8px" }}
              />
                Product Wishlist
              </div>
            </a>
            <div className="dropdown-divider"></div>
            <a
              href={BRIGIZ_APP_E_COM_ADDRESS}
              onClick={() => setIsDropdownOpen(false)}
              style={{color:'#ded8d8'}}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <TbAddressBook
                  style={{ width: "17px", height: "17px", marginRight: "8px" }}
                />
                Address
              </div>
            </a> */}
            <div className="dropdown-divider"></div>
            <Link
              to="/logout"
              onClick={() => {
                setIsDropdownOpen(false);
                logoutbutton();
              }}
            >
              <MdLogout
                style={{ width: "18px", height: "18px", marginRight: "8px" }}
              />
              Log Out
            </Link>
          </nav>
        </div>
      )}
    </section>
  );
};

export default Header;
